import {FiltersConfig} from './filters-config.model';

export class DescriptorFacetConfig {
  facets: FiltersConfig = new FiltersConfig({});
  typesWithFilters = new Map<string, string>();


  constructor(attr: {facets?: FiltersConfig}) {
    if (attr.facets) {
      this.facets = attr.facets;
    }
  }

  getFilterByType(type: string) {
    const filter = this.typesWithFilters.get(type);
    if (filter) {
      return filter;
    }
  }

  putFilterByType(type: string, filter: string) {
    if (type && filter) {
      this.typesWithFilters.set(type, filter);
    }
  }


}
